import { MatrixPropertyValidator } from 'app/models/questions/property-validator/MatrixPropertyValidator'
import { ICheckbox } from 'app/interfaces/ICheckbox'

export class CheckboxMatrixPropertyValidator extends MatrixPropertyValidator implements ICheckbox {
  uniqueMentionKey: string

  constructor(question) {
    super(question)

    this.uniqueMentionKey = question.uniqueMentionKey
  }
}
